

export const routePath = { 
  home          : '/',
  create        : '/create',
  posts         : '/posts'
}

